export default __webpack_public_path__ + "49de45608a716c657f5e3085791c12cf.ttf";